<template>
    <div class="btns-box">
        <p
            v-for="(item,index) in newForm"
            :key="index"
            class="btn"
            :class="{hide: item.isHide}"
            :style="`${item.color? 'color:'+item.color:''}`"
            @click="handleClick(index, item)"
        >
            <span
                :class="{
                    iconfont: true,
                    [item.icon]: true,
                    add: ['icon-add'].includes(item.icon),
                    del: ['icon-del'].includes(item.icon)
                }"
            ></span>{{item.name}}
        </p>
    </div>
</template>

<script>
    export default {
        name: "Btns",
        props: {
            form: [Array, Object]
        },
        computed:{
            newForm(){
                return this.form
            }
        },
        width: {
            form:{
                handler(vl){
                    this.newForm=vl
                },
                deep: true,
                immediate: true
            }
        },
        data(){
            return {
                // newForm: this.form
            }
        },
        methods: {
            handleClick(index, item){
                this.$emit('onBtns', { index, item })
            }
        }
    }
</script>

<style lang="scss" scoped>
.btns-box{
    display: flex;
    flex-direction: row;
    align-items: center;

    .btn{
        margin-right: 10px;
        color: #13ce66;
        cursor: pointer;
        user-select: none;

        .add{
            color: #5cb87a;
            font-size: 20px;
        }

        .del{
            color: #ff4545;
            font-size: 20px;
        }

        &.hide{
            display: none;
        }

        &:active {
            opacity: .6;
        }
    }
}
</style>
